import React from 'react';

export const FooterBtn = ({
  title = '',
  bgColor = '#4B9B42',
  borderRadius = 8,
  titleColor = '#FFF',
  padding = 10,
  onClick,
  isDisabled = false,
  info = null,
}) => {
  if (!title.length) return null;
  if (isDisabled) bgColor = '#B5B5B5';
  const handleClick = () => {
    if (isDisabled) {
      return false;
    }
    return onClick();
  };
  return (
    <div className='tw-flex-col tw-gap-4'>
      {info}
      <div
        className='footer_btn'
        style={{
          background: bgColor,
          borderRadius: borderRadius,
          padding: padding,
          justifyContent: 'center',
          cursor: isDisabled ? 'not-allowed' : 'pointer',
        }}
        onClick={handleClick}
        data-dd-action-name={title || 'Submit'}
      >
        <p
          className='footer_btn_title'
          style={{
            color: titleColor,
          }}
        >
          {title}
        </p>
      </div>
    </div>
  );
};
